import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { installPreloadErrorReload } from './lib/chunkReload'
import './index.css'
import '@/ui/tokens.css'
import './global.css'

// 배포 직후 옛 청크 로드 실패 → 1회 자동 새로고침 (FIKET-359)
installPreloadErrorReload()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
